import { render } from "./storage-settings-modal.vue?vue&type=template&id=460b80dd"
import script from "./storage-settings-modal.vue?vue&type=script&lang=js"
export * from "./storage-settings-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__